import { __makeTemplateObject } from "tslib";
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { color } from '@metro-ui/tokens/js';
import { Lock as LockIcon } from '../../icons/icons/Lock';
export var Lock = styled(LockIcon, {
    shouldForwardProp: function (prop) { return prop !== 'isReduced'; },
})(function (_a) {
    var isReduced = _a.isReduced;
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    position: absolute;\n    top: 0;\n    left: 0.625rem;\n\n    height: 2.5rem;\n    width: 1.25rem;\n    color: ", ";\n\n    ", "\n  "], ["\n    position: absolute;\n    top: 0;\n    left: 0.625rem;\n\n    height: 2.5rem;\n    width: 1.25rem;\n    color: ", ";\n\n    ", "\n  "])), color.muted, isReduced && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      left: 0.25rem;\n      font-size: 0.75rem;\n      height: 1.5rem;\n    "], ["\n      left: 0.25rem;\n      font-size: 0.75rem;\n      height: 1.5rem;\n    "]))));
});
var templateObject_1, templateObject_2;
//# sourceMappingURL=Lock.js.map